function getC24App() {
    if (!('C24App' in window)) {
        return false;
    }
    return window.C24App;
}

function callAppBridge(iOSCallback, androidCallback) {
    const c24App = getC24App();
    if (!c24App) {
        return false;
    }
    if (window.webkit?.messageHandlers !== undefined) {
        iOSCallback();
    } else if (window.AndroidPRNKB !== undefined) {
        androidCallback();
    }
}

export const emitPbeChangeSuccess = () => {
    // claim success
    callAppBridge(
        () =>
            window.webkit?.messageHandlers?.customerAreaContentChange?.postMessage({
                success: true,
            }),
        () => window.AndroidPRNKB?.customerAreaContentChange?.()
    );
};

// close webview
export const emitPbeCloseWebview = () => {
    callAppBridge(
        () =>
            window.webkit?.messageHandlers?.customerAreaCloseWebview?.postMessage({
                success: true,
            }),
        () => window.AndroidPRNKB?.customerAreaCloseWebview?.()
    );
};
